import { UseMutationDefaultOptions } from '@front/hook/Api/common';
import { importTableDefinitionQueryKeys } from '@front/hook/Api/ImportTableDefinition/queryKeys';
import { importTaskQueryKeys } from '@front/hook/Api/ImportTask/queryKeys';
import { DEFAULT_TIMEOUT } from '@front/hook/Api/utils/consts';
import { signalToTimeout } from '@front/hook/Api/utils/signalToTimeout';
import { AdminRepository } from '@front/repository/Api/Admin';
import type { IAdminRepository } from '@front/repository/Api/Admin/interface';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const repository = new AdminRepository();

export const _forceRemoveImportTableDefinition = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: IAdminRepository.ForceRemoveImportTableDefinition.Params) => {
      return repository.forceRemoveImportTableDefinition(params, { signal: signalToTimeout(DEFAULT_TIMEOUT.MUTATION) });
    },
    onSuccess: (_data, variables) => {
      queryClient.removeQueries({
        queryKey: importTableDefinitionQueryKeys.detail(variables.projectId, variables.id),
      });
      void queryClient.invalidateQueries({
        queryKey: importTableDefinitionQueryKeys.listPrefix(variables.projectId),
      });
      void queryClient.invalidateQueries({
        queryKey: importTaskQueryKeys.listPrefix(variables.projectId),
      });
    },
    ...UseMutationDefaultOptions,
  });
};
